import {addClass, removeClass, hasClass} from './../helpers/dom';

export class SingleProduct {
  constructor() {
    this.varietySelectHandler = this.varietySelectHandler.bind(this);
  }

  init() {
    this.varietyBtnElems = document.querySelectorAll('.js-variety-select-btn');
    this.targetSingleImage = document.querySelector('img.js-single-image');
    this.varietyBtnActiveEl = document.querySelector('.variety-select-btn-active');
    this.btnResetVarietySelect = document.getElementById('reset-variety-select');

    this.initVarietySelect();

    if (this.btnResetVarietySelect) {
      this.btnResetVarietySelect.addEventListener('click', (e) => {
        this.resetVarietySelect();
        this.toggleBtnResetVarietyVisibility(false);
      });
    }
  }

  toggleBtnResetVarietyVisibility(visible) {
    if (visible) {
      removeClass(this.btnResetVarietySelect, 'd-none');
      addClass(this.btnResetVarietySelect, 'd-inline-block');
    } else {
      addClass(this.btnResetVarietySelect, 'd-none');
      removeClass(this.btnResetVarietySelect, 'd-inline-block');
    }
  }

  initVarietySelect() {
    [].forEach.call(this.varietyBtnElems, (elem) => {
      elem.addEventListener('click', this.varietySelectHandler);
    });
  }

  varietySelectHandler(e) {
    e.preventDefault();
    this.resetVarietySelect();
    const {targetImgSrc} = e.target.dataset;

    if (this.targetSingleImage) {
      this.targetSingleImage.src = targetImgSrc;
      addClass(e.target, 'variety-select-btn-active');
      this.varietyBtnActiveEl = e.target;

      if (!hasClass(e.target, 'close')) {
        this.toggleBtnResetVarietyVisibility(true);
      }
    }
  }

  resetVarietySelect() {
    if (this.varietyBtnActiveEl) {
      removeClass(this.varietyBtnActiveEl, 'variety-select-btn-active');
    }
  }
}
